import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_PRIMARYGOAL,
  ADD_PRIMARY_GOALS,
  UPDATE_PRIMARY_GOALS,
  DELETE_PRIMARY_GOALS,
  GET_GOALS_SUCCESS,
  ADD_PRIMARY_GOALS_SUCCESS,
  UPDATE_PRIMARY_GOALS_SUCCESS,
  DELETE_PRIMARY_GOALS_SUCCESS,
  GET_GOALS_BY_DESIGNATION,
  GET_GOALS_BY_DESIGNATION_SUCCESS,

} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function* getPrimaryGoalAPi() {
  // api for get designations
  const response =  yield api.Dbprimarygoal().GetGoalList();

  return response;
}

function addPrimayGoalsApi(formData) {
  // api for add designation.
  api.Dbprimarygoal().AddEditGoal(formData);
}
function updatePrimaryGoalApi(formData) {
  // api for update designation.
  api.Dbprimarygoal().AddEditGoal(formData);
}
function delPrimaryGoalApi(payload) {
  // api for delete designation
  const response = api.Dbprimarygoal().DeleteGoal(payload);
  return response;
}
// get goals by designation.
function* getGoalsByDesignationApi(payload) {
  const response = yield api.appraisal().GetGoalListByDesignationId(payload);
  return response.data;
}
// get goals by designation.
export function* handleGetGoalsByDesignation({payload}) {
  try {
    const response = yield call(getGoalsByDesignationApi,payload);
    yield put({ type: GET_GOALS_BY_DESIGNATION_SUCCESS, payload: response });
  } catch (error) {
 
  }
}
// get designation list.njj
export function* handleGetPrimaryGoal() {
  try {
    const GoalData = yield call(getPrimaryGoalAPi);
    yield put({ type: GET_GOALS_SUCCESS, payload: GoalData.data });
  } catch (error) {

  }
}
export function* handleAddPrimaryGoal({ payload }) {
  try {
    yield call(addPrimayGoalsApi, payload);

    yield put({ type: ADD_PRIMARY_GOALS_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleUpdatePrimaryGoal({ payload }) {
  try {
    yield call(updatePrimaryGoalApi, payload);
    yield put({ type: UPDATE_PRIMARY_GOALS_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleDelPrimaryGoal({ payload }) {
  try {
    yield call(delPrimaryGoalApi, payload);
    yield put({ type: DELETE_PRIMARY_GOALS_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}

// watch function.
export function* primarygoalWatchFun() {
  yield takeLatest(GET_PRIMARYGOAL, handleGetPrimaryGoal);
  yield takeLatest(ADD_PRIMARY_GOALS, handleAddPrimaryGoal);
  yield takeLatest(UPDATE_PRIMARY_GOALS, handleUpdatePrimaryGoal);
  yield takeLatest(DELETE_PRIMARY_GOALS, handleDelPrimaryGoal);
  yield takeLatest(GET_GOALS_BY_DESIGNATION, handleGetGoalsByDesignation);
}
